import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import TruvBridge from '@truv/react';

/**
 * Truv Bridge Component
 * Initializes the Truv Bridge with a bridge token using @truv/react
 *
 * https://docs.truv.com/docs/event-reference-for-truv-bridge
 */

export const Truv = (): JSX.Element => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [isOpened, setOpened] = useState(false);

  // Decode and parse token
  let accessToken: string | null = null;
  let error: Error | null = null;

  if (token) {
    try {
      const decoded = atob(token);
      const parsed = JSON.parse(decoded);
      accessToken = parsed.accessToken;
    } catch (e) {
      error = e as Error;
      console.error('Error decoding token:', e);
    }
  }

  // Auto-open when bridgeToken is provided
  useEffect(() => {
    if (accessToken) {
      setOpened(true);
    }
  }, [accessToken]);

  const handleClose = () => {
    setOpened(false);
    console.log('DEBUG TRUV onClose');
  };

  const handleSuccess = (publicToken: string, metaData: any) => {
    console.log('DEBUG TRUV onSuccess', publicToken, metaData);
  };

  if (!token) {
    return <div>Error: Missing token parameter</div>;
  }

  if (error) {
    return <div>Error: Invalid token format</div>;
  }

  if (!accessToken) {
    return <div>Error: Missing accessToken in token</div>;
  }

  console.log('DEBUG TRUV accessToken', accessToken);

  return (
    <TruvBridge
      bridgeToken={accessToken}
      onClose={handleClose}
      onSuccess={handleSuccess}
      isOpened={isOpened}
    />
  );
};

